import React, { useEffect, useState } from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import Header from "../header/Header";
import Sidebarr from "../sidebar/Sidebar";
import VendorSidebar from "../sidebar/VendorSidebar";
import Tool from "../sidebar/Tool";
import Footer from "../footer/Footer";
import axios from "../helper/axios";
import { useSelector } from "react-redux";

export default function EditBanner() {
  const navigate = useNavigate();
  const { bannerId } = useParams();
  const auth = useSelector((state) => state.auth);

  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState(null);
  const [bannerType, setBannerType] = useState("image");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [isActive, setIsActive] = useState(true);
  const [targetUrl, setTargetUrl] = useState("/products?discount=yes");
  const [linkName, setLinkName] = useState("");
  const [bannerUrl, setBannerUrl] = useState("");

  const loadBanner = async () => {
    if (!bannerId) {
      setError("ID e banerit mungon.");
      setLoading(false);
      return;
    }
    try {
      setLoading(true);
      setError(null);
      const res = await axios.post("/getbannerbyid", { bannerId });
      if (res.status === 200 && res.data) {
        const b = res.data;
        setBannerType(b.bannerType || "image");
        setStartDate(b.startDate ? new Date(b.startDate).toISOString().split("T")[0] : "");
        setEndDate(b.endDate ? new Date(b.endDate).toISOString().split("T")[0] : "");
        setIsActive(b.isActive !== undefined ? b.isActive : true);
        setTargetUrl(b.targetUrl || "/products?discount=yes");
        setLinkName(b.linkName || "");
        setBannerUrl(b.bannerUrl || b.bannerImage || "");
      } else {
        setError("Baneri nuk u gjet.");
      }
    } catch (err) {
      console.error("Error loading banner:", err);
      setError(err.response?.data?.error || err.message || "Gabim gjatë ngarkimit.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadBanner();
  }, [bannerId]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!bannerId) return;
    if (!startDate || !endDate) {
      alert("Ju lutem plotësoni datën e fillimit dhe datën e mbarimit.");
      return;
    }
    try {
      setSaving(true);
      const res = await axios.post("/updatebannerconfig", {
        bannerId,
        bannerType,
        startDate,
        endDate,
        isActive,
        targetUrl: targetUrl || "/products?discount=yes",
        linkName: linkName || ""
      });
      if (res.status === 200) {
        alert("Baneri u përditësua me sukses!");
        navigate("/banner");
      } else {
        alert(res.data?.error || "Diçka shkoi keq.");
      }
    } catch (err) {
      console.error("Error updating banner:", err);
      alert(err.response?.data?.error || err.response?.data?.details || err.message || "Gabim gjatë ruajtjes.");
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="sidebar-mini skin-green-light">
      <div className="wrapper">
        <Header />
        {auth?.user?.role === "Vendor" ? <VendorSidebar /> : <Sidebarr />}

        <div className="content-wrapper">
          <section className="content-header">
            <h1>Ndrysho baner</h1>
            <ol className="breadcrumb">
              <li><a href="#">Home</a></li>
              <li><Link to="/banner">Banners</Link></li>
              <li className="active">Edit</li>
            </ol>
          </section>

          <section className="content">
            <div className="box">
              <div className="box-header with-border">
                <div className="box-tools pull-right">
                  <Link to="/banner" className="btn btn-default">
                    <i className="fa fa-arrow-left" /> Lista e banerave
                  </Link>
                </div>
              </div>
              <div className="box-body">
                {loading && <p className="text-muted">Duke ngarkuar...</p>}
                {error && <div className="alert alert-danger">{error}</div>}
                {!loading && !error && (
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-xs-12">
                        <label>Parashtrimi aktual</label>
                        <div className="thumbnail" style={{ maxWidth: 400 }}>
                          {bannerType === "video" ? (
                            <video src={bannerUrl} controls style={{ width: "100%" }} />
                          ) : (
                            <img src={bannerUrl} alt="Banner" style={{ width: "100%", display: "block" }} />
                          )}
                          <small className="text-muted">Ndryshimi i imazhit/videos bëhet duke shtuar një baner të ri dhe fshirjen e këtij.</small>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-xs-12">
                        <label>Lloji i banerit</label>
                        <select
                          className="form-control"
                          value={bannerType}
                          onChange={(e) => setBannerType(e.target.value)}
                        >
                          <option value="image">Foto</option>
                          <option value="video">Video</option>
                        </select>
                      </div>
                    </div>
                    <br />
                    <div className="row">
                      <div className="col-xs-12">
                        <label>URL link (ku të çon baneri)</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="/products?discount=yes"
                          value={targetUrl}
                          onChange={(e) => setTargetUrl(e.target.value)}
                        />
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-xs-12">
                        <label>Emri / etiketa (opsional)</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Link name"
                          value={linkName}
                          onChange={(e) => setLinkName(e.target.value)}
                        />
                      </div>
                    </div>
                    <br />
                    <div className="row">
                      <div className="col-xs-6">
                        <label>Data fillimi</label>
                        <input
                          type="date"
                          className="form-control"
                          value={startDate}
                          onChange={(e) => setStartDate(e.target.value)}
                          required
                        />
                      </div>
                      <div className="col-xs-6">
                        <label>Data mbarimi</label>
                        <input
                          type="date"
                          className="form-control"
                          value={endDate}
                          onChange={(e) => setEndDate(e.target.value)}
                          required
                        />
                        <small className="text-muted">Baneri shfaqet deri në 23:59 të kësaj date (mund të zgjidhni edhe datë në të kaluarën).</small>
                      </div>
                    </div>
                    <br />
                    <div className="row">
                      <div className="col-xs-12">
                        <label>
                          <input
                            type="checkbox"
                            checked={isActive}
                            onChange={(e) => setIsActive(e.target.checked)}
                          />
                          {" "}Aktiv (baneri shfaqet nëse data është e saktë)
                        </label>
                      </div>
                    </div>
                    <br />
                    <div className="row">
                      <div className="col-xs-12">
                        <button type="submit" className="btn btn-primary" disabled={saving}>
                          {saving ? "Duke ruajtur..." : "Ruaj ndryshimet"}
                        </button>
                        {" "}
                        <Link to="/banner" className="btn btn-default">Anulo</Link>
                      </div>
                    </div>
                  </form>
                )}
              </div>
            </div>
          </section>
        </div>

        <Footer />
        <Tool />
        <div className="control-sidebar-bg" />
      </div>
    </div>
  );
}
